import React, { Component } from "react";
import {
  Modal,
  Image,
  Container,
  Transition
} from "semantic-ui-react";
import { connect } from "react-redux";
import { Loader } from "../Loader/Loader";
import { mobileMatchMedia, googleTracking } from "../../util";
import { withRouter } from 'react-router-dom';
import btnCloseXs from "../../semantic/dist/themes/fibrestream/assets/images/close.svg";
import btnCloseSm from "../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import defaultBuilding from "../../semantic/dist/themes/fibrestream/assets/images/default-building-small.jpg";
import {
  setUnitNo,
  setConnection,
  resetConnection,
  setStatus,
  setAutofocus
} from "../../store/actions/connection";
import { Config } from "../../data/config";
import { setTitle, setMetaDescription } from '../../util';
import {
  AVAILABLE_NOT_PREWIRED,
  UNAVAILABLE
} from "../../data/status";
import { getSalesRep } from "../../store/actions/sales-rep";
import { getTaxes } from "../../store/actions/taxes";
import { getBeanid } from "../../store/actions/beanid";
import { setAvailabilityModal } from '../../store/actions/app';
import Availability from 'fs-availability';

class CheckAvailabilityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      errors: {},
      visibleDropdown: props.addressId ? false : true,
      unitPlaceholderText: null,
      isLoading: false
    };
    this.unitRef = React.createRef();

    this.next = this.next.bind(this);
    this.onChange = this.onChange.bind(this);
    this.editAddress = this.editAddress.bind(this);
    this.resetError = this.resetError.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onDropdownValueChange = this.onDropdownValueChange.bind(this);
    this.getUnitPlaceholderText = this.getUnitPlaceholderText.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.addDefaultSrc = this.addDefaultSrc.bind(this);
    this.closeAvailabilityModal = this.closeAvailabilityModal.bind(this);
    this.onHistoryChange = this.onHistoryChange.bind(this);
    this.setConnection = this.setConnection.bind(this);

    this.autoCompleteRef = null;
    this.sliderRef = null;
  }

  addDefaultSrc(e, bid) {
    e.target.src = defaultBuilding
  }
  onDropdownValueChange(prevProps) {
    if (
      prevProps.addressId !== this.props.addressId &&
      this.props.addressId !== null
    ) {
      this.setState({
        visibleDropdown: false
      });
    }

    if (this.props.addressId) {
      setTimeout(() => {
        if (this.unitRef.current) {
          this.unitRef.current.focus();
        }
      });
    }
  }

  registerEventListener() {
    window.addEventListener("resize", this.getUnitPlaceholderText);
  }

  getUnitPlaceholderText() {
    if (this.isComponentMounted) {
      this.setState({
        unitPlaceholderText: mobileMatchMedia() ? "Unit" : "Unit #"
      });
    }
  }
  componentDidUpdate(prevProps) {
    this.onDropdownValueChange(prevProps);
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        prevPathname: prevProps.location.pathname
      })
    }
  }

  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);

    googleTracking({
      event: "virtualPageview",
      pageview: "/step1/check-availability"
    });

    this.isComponentMounted = true;
    if (this.props.history.location.pathname !== '/check') {
      this.props.history.push('/check');
    }

    this.setState({
      visible: true,
    });

    this.registerEventListener();
    this.getUnitPlaceholderText();
    document.addEventListener("mousedown", this.handleClick, false);
  }

  handleClick(e) {
    if (this.autoCompleteRef && this.autoCompleteRef.contains(e.target)) {
      return;
    }
    if (this.sliderRef && this.sliderRef.contains(e.target)) {
      return;
    }
    this.closeAvailabilityModal();
  }

  editAddress() {
    this.props.setConnection({
      addressId: null,
      bid: null,
      city: null,
      province: null,
      result_type: null
    });
    this.setState({
      visibleDropdown: true
    });
  }

  onChange(e) {
    this.props.setUnitNo(e.target.value);
    if (this.state.errors.unitNo) {
      delete this.state.errors.unitNo;
      this.setState({
        errors: this.state.errors
      });
    }
  }

  resetError() {
    if (this.state.errors.addressId) {
      delete this.state.errors.addressId;
      this.setState({
        errors: this.state.errors
      });
    }
  }

  nextEffect() {
    this.redirect();
  }

  onKeyPress(e) {
    const isEnterKeyPressed = e.nativeEvent.keyCode === 13;
    if (isEnterKeyPressed) {
      this.next();
    }
  }

  redirect() {
    const { history } = this.props;
    history.push("/check-availability");
  }

  next() {
    const { isOnNet, isFibrestream } = this.props;

    googleTracking({
      event: "GAevent",
      eventCategory: "address-submission",
      eventAction: "submit",
      eventLabel: `${this.props.address}, ${this.props.city}`,
      "address-submitted": `${this.props.addressId}, ${this.props.city}`
    });

    if (isFibrestream || isOnNet) {
      this.props.setStatus(AVAILABLE_NOT_PREWIRED);
    } else {
      // nothing is available
      this.props.setStatus(UNAVAILABLE);
    }
    this.nextEffect();
  }

  componentWillUnmount() {

    this.isComponentMounted = false;
    window.removeEventListener("resize", this.getUnitPlaceholderText);
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  closeAvailabilityModal(e) {
    const {
      isLoading,
    } = this.state;
    if (isLoading) {
      return;
    }
    const { history, closeModal, openAvailabilityModal, setAvailabilityModal } = this.props;
    this.props.setAutofocus(false);


    if (typeof closeModal !== 'undefined') {
      closeModal();
      return;
    }

    setTimeout(() => {
      if ((history.location.pathname === '/check') && (this.props.prevPathname !== null)) {
        setAvailabilityModal(false);
        history.push(this.props.prevPathname);
      }
      else if ((history.location.pathname === '/check') && (this.props.prevPathname === null)) {
        setAvailabilityModal(false);
        history.push('/');
      }
      else if (openAvailabilityModal) {
        setAvailabilityModal(false);
      }
    });

  }

  setConnection(building) {
    this.props.setConnection(building);
    if (building.hasOwnProperty("promo")) {
      this.props.history.push(`/promotion/${building.promo}`);
    }
  }

  loadBuilding(building, e) {
    this.props.setConnection(building);
  }

  onComplete() {
    
  }

  onHistoryChange(e) {
    if (e.alwaysDisplay) {
      this.props.history.push(e.url);
      return;
    }
  }

  render() {
    const {
      isLoading
    } = this.state;
    const {
      unitNo,
      open,
      visible,
      autofocus
    } = this.props;

    return (
      <Transition visible={visible} animation="slide up" duration={500} >
        <Modal
          closeOnDimmerClick={!isLoading}
          closeOnDocumentClick={!isLoading}
          closeOnEscape={!isLoading}
          open={open}
          onClose={this.closeAvailabilityModal}
          style={{ boxShadow: "none", height: "100%" }}
          className="bg--black vertical fullscreen modal__map modal__check-availability centered grid scrolling"
          id="check-availability-modal"
        >

          <Modal.Content className="scrolling ui centered grid bg--black">
            <Modal.Actions className="ui grid right aligned border-0">
              <button className="ui button deny close" onClick={this.closeAvailabilityModal}>
                <span className="times text-white"><Image src={mobileMatchMedia() ? btnCloseXs : btnCloseSm} verticalAlign='middle' /></span>
              </button>
            </Modal.Actions>
            <section className="check-availability in-modal space avail-step">
              <Container>
                <div ref={node => (this.autoCompleteRef = node)}>
                  <Availability
                    title="Check Availability"
                    url={`${Config.addressSearchApiUrl}/api/v1/search/address`}
                    onHistoryChange={this.onHistoryChange}
                    minChar={2}
                    setConnection={this.setConnection}
                    setUnitNo={this.props.setUnitNo}
                    address={this.props.addressId}
                    editAddress={this.editAddress}
                    optionSelectedText={this.props.addressText}
                    unitNo={unitNo}
                    next={this.next}
                    isLoading={isLoading}
                    loaderComponent={<Loader />}
                    autofocus={autofocus}
                    recaptchaSiteKey={process.env.REACT_APP_BF_RECAPTCHA_SITE_KEY}
                    recaptchaVerifyUrl={`${Config.addressSearchApiUrl}/api/v2/rate-limit/verify`}
                  />
                </div>
              </Container>
            </section >
          </Modal.Content >
        </Modal >
      </Transition >
    );
  }
}

const mapStateToProps = state => {
  return {
    addressId: state.connection.addressId,
    addressText: state.connection.addressText,
    city: state.connection.city,
    bid: state.connection.bid,
    unitNo: state.connection.unitNo,
    isOnNet: state.connection.isOnNet,
    isFibrestream: state.connection.isFibrestream,
    openAvailabilityModal: state.app.openAvailabilityModal,
    prevPathname: state.app.prevPathname,
    autofocus: state.connection.autofocus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setConnection: data => dispatch(setConnection(data)),
    setUnitNo: value => dispatch(setUnitNo(value)),
    resetConnection: () => dispatch(resetConnection()),
    setStatus: status => dispatch(setStatus(status)),
    getSalesRep: id => dispatch(getSalesRep(id)),
    getTaxes: id => dispatch(getTaxes(id)),
    getBeanid: id => dispatch(getBeanid(id)),
    setAvailabilityModal: (flag) => dispatch(setAvailabilityModal(flag)),
    setAutofocus: (flag) => dispatch(setAutofocus(flag))
  };
};

CheckAvailabilityModal = withRouter(CheckAvailabilityModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckAvailabilityModal);



// WEBPACK FOOTER //
// ./src/components/check-availability-modal/checkAvailabilityModal.js